import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import logoImage from "./assets/logo.png";
import Button from "./components/ui/Button";
import Input from "./components/ui/Input";
import { useLogin } from "./hooks/useLogin";

const Login = () => {
  const handleLogin = useLogin();
  const [errorMsg, setErrorMsg] = useState("");
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // Parallax effect - track mouse movement
  useEffect(() => {
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const { innerWidth, innerHeight } = window;
      // Normalize to -1 to 1 range, with subtle movement (max 20px)
      const x = ((clientX / innerWidth) - 0.5) * 20;
      const y = ((clientY / innerHeight) - 0.5) * 20;
      setMousePosition({ x, y });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const onLogin = (formData) => {
    const name = formData.get("name");
    const password = formData.get("password");

    const error = handleLogin(name, password);
    if (error) {
      setErrorMsg(error);
    }
  };

  return (
    <main className="flex flex-col items-center justify-center min-h-screen bg-white p-4">
      {/* Subtle animated background logo */}
      <motion.div
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
        animate={{
          x: mousePosition.x,
          y: mousePosition.y,
        }}
        transition={{
          type: "spring",
          stiffness: 50,
          damping: 30,
        }}
      >
        <motion.img
          src={logoImage}
          alt=""
          className="w-[90%] max-w-[950px] h-auto object-contain opacity-[0.08]"
          animate={{
            scale: [1, 1.05, 1],
          }}
          transition={{
            scale: {
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
            },
          }}
        />
      </motion.div>

      <div className="max-w-xs w-full bg-white z-10 p-6 rounded-xl shadow-lg border border-gray-200 flex flex-col items-center gap-3">
        <h1 className="text-2xl sm:text-3xl font-bold flex items-center">
          <span className="text-blue-600">Neuro</span><span className="text-gray-800">Hubs</span>
        </h1>
        <h2 className="text-xl font-semibold text-gray-700">Login</h2>
        <form className="flex flex-col gap-3 w-full" action={onLogin}>
          <Input
            label="Username"
            type="text"
            onChange={() => {}}
            name="name"
            placeholder="Username"
            required
            className="w-full"
            autocomplete="username"
          />
          <Input
            label="Password"
            type="password"
            onChange={() => {}}
            name="password"
            placeholder="Password"
            required
            className="w-full"
            autocomplete="current-password"
          />
          <Button
            onClick={() => {}}
            type="submit"
            className="text-white px-3 py-1 md:px-4 md:py-1.5 mt-2 w-full"
          >
            Login
          </Button>
        </form>
        {errorMsg && (
          <p className="text-red-500 mt-2 text-center">{errorMsg}</p>
        )}
      </div>
    </main>
  );
};

export default Login;
